import registerRootComponent from 'expo/build/launch/registerRootComponent';
import App from './index.js';
registerRootComponent(App);